module.exports = __webpack_public_path__ + "static/scale-model-of-beech-creek-preserve-in-athens-georgia-0fbd75112a4b4076c03deaa46a026ecc.png";